import React, { useContext } from "react";
import { MarcasContext } from "../../context/MarcasContext";
import "./index.scss";

import Instagram from "../../assets/images/Instagram.png";
import Facebook from "../../assets/images/Facebook.png";

import WhatsappFlotante from "../../assets/images/WhatsappFlotante.png";

export const Footer = () => {
  const { marcas } = useContext(MarcasContext);

  return (
    <footer>
      <section className="contenedorFooter-black-title">
        <h3>SERVICE DE POSVENTA OFICIAL</h3>
      </section>
      <section className="contenedorFooter-black">
        <div className="columnasFooter">
          <div className="columnasFooter-link">
            <a href="https://montironiford.com/" target="_blank" rel="noreferrer">
              montironiford.com.ar
            </a>
            <a href="https://montironiford.com/posventa-opciones/" target="_blank" rel="noreferrer">
              Ford Posventa
            </a>
            <a href="https://montironiford.com/contacto/" target="_blank" rel="noreferrer">
              Contactos
            </a>
            <a href="https://montironiford.com/contacto/" target="_blank" rel="noreferrer">
              Ver ubicaciones
            </a>
          </div>
          <div className="contenedorRedesSocialesFooter">
            <a href="https://www.instagram.com/montironi.ford/" target="_blank" rel="noreferrer">
              <img src={Instagram} alt="Icon Instagram" />
            </a>
            <a href="https://www.facebook.com/MontironiFord" target="_blank" rel="noreferrer">
              <img src={Facebook} alt="Icon Facebook" />
            </a>
          </div>
        </div>
        <div className="columnasFooter">
          <div className="columnasFooter-link">
            <a href="https://www.montironifiat.com.ar/" target="_blank" rel="noreferrer">
              montironifiat.com.ar
            </a>
            <a href="https://www.montironifiat.com.ar/post_venta/" target="_blank" rel="noreferrer">
              Fiat Posventa
            </a>
            <a href="https://www.montironifiat.com.ar/contacto/" target="_blank" rel="noreferrer">
              Contactos
            </a>
            <a href="https://www.montironifiat.com.ar/contacto/" target="_blank" rel="noreferrer">
              Ver ubicaciones
            </a>
          </div>
          <div className="contenedorRedesSocialesFooter">
            <a href="https://www.instagram.com/montironi.fiat/" target="_blank" rel="noreferrer">
              <img src={Instagram} alt="Icon Instagram" />
            </a>
            <a href="https://www.facebook.com/MontironiFiat" target="_blank" rel="noreferrer">
              <img src={Facebook} alt="Icon Facebook" />
            </a>
          </div>
        </div>
        <div className="columnasFooter">
          <div className="columnasFooter-link">
            <a href="https://montironijeep.com/" target="_blank" rel="noreferrer">
              montironijeep.com.ar
            </a>
            <a href="https://montironijeep.com/post_venta/" target="_blank" rel="noreferrer">
              Jeep Posventa
            </a>
            <a
              href="https://www.google.com/maps/dir/-31.3462739,-64.2133241/montironi+jeep/@-31.1660894,-64.2890393,11z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x9432638341399fc3:0xb7455a0cde34448d!2m2!1d-64.0846745!2d-30.976328"
              target="_blank"
              rel="noreferrer"
            >
              Ver ubicaciones
            </a>
            <a href="https://montironijeep.com/contacto/" target="_blank" rel="noreferrer">
              Contactos
            </a>
          </div>
          <div className="contenedorRedesSocialesFooter">
            <a href="https://www.instagram.com/montironi.jeep/" target="_blank" rel="noreferrer">
              <img src={Instagram} alt="Icon Instagram" />
            </a>
            <a href="https://www.facebook.com/Montironi-Jeep-107981411797027" target="_blank" rel="noreferrer">
              <img src={Facebook} alt="Icon Facebook" />
            </a>
          </div>
        </div>
        <div className="columnasFooter">
          <div className="columnasFooter-link">
            <a href="https://automonthyundai.com.ar/" target="_blank" rel="noreferrer">
              montironihyundai.com.ar
            </a>
            <a href="https://automonthyundai.com.ar/posventa/" target="_blank" rel="noreferrer">
              Hyundai Posventa
            </a>
            <a
              href="https://www.google.com/maps/place/Automont+Hyundai/@-31.390287,-64.204572,15z/data=!4m5!3m4!1s0x0:0xd3362f1d1132a473!8m2!3d-31.390287!4d-64.204572?sa=X&ved=2ahUKEwil-uTl6rfwAhXPppUCHRcmAlkQ_BIwEnoECB8QBQ&shorturl=1"
              target="_blank"
              rel="noreferrer"
            >
              Ver ubicaciones
            </a>
            <a href="https://automonthyundai.com.ar/contacto/" target="_blank" rel="noreferrer">
              Contactos
            </a>
          </div>
          <div className="contenedorRedesSocialesFooter">
            <a href="https://www.instagram.com/automont.hyundai/" target="_blank" rel="noreferrer">
              <img src={Instagram} alt="Icon Instagram" />
            </a>
            <a href="https://www.facebook.com/Automont.Hyundai" target="_blank" rel="noreferrer">
              <img src={Facebook} alt="Icon Facebook" />
            </a>
          </div>
        </div>
        <div className="columnasFooter">
          <div className="columnasFooter-link">
            <a href="https://montironipeugeot.com.ar/" target="_blank" rel="noreferrer">
              montironipeugeot.com.ar
            </a>
            <a href="https://montironipeugeot.com.ar/post_venta/" target="_blank" rel="noreferrer">
              Peugeot Posventa
            </a>
            <a href="https://goo.gl/maps/GgJRS6zRck3HUtCm8" target="_blank" rel="noreferrer">
              Ver ubicaciones
            </a>
            <a href="https://montironipeugeot.com.ar/contacto/" target="_blank" rel="noreferrer">
              Contactos
            </a>
          </div>
          <div className="contenedorRedesSocialesFooter">
            <a href="https://instagram.com/MontironiPeugeot" target="_blank" rel="noreferrer">
              <img src={Instagram} alt="Icon Instagram" />
            </a>
            <a href="https://www.facebook.com/MontironiPeugeot" target="_blank" rel="noreferrer">
              <img src={Facebook} alt="Icon Facebook" />
            </a>
          </div>
        </div>
      </section>
      <section className="contenedorFooter-copy">
        <p>Montironi Automotores. Todos los derechos reservados.</p>
      </section>
      <div className="contenedorWhatsappFloante">
        {marcas === "fiat" ? (
          <a
            href="https://api.whatsapp.com/send?phone=543516825130&text=Hola%20Montironi!%20"
            target="_blank"
            rel="noreferrer"
          >
            <img src={WhatsappFlotante} alt="Whatsapp" />
          </a>
        ) : null}
        {marcas === "ford" ? (
          <a
            href="https://api.whatsapp.com/send?phone=543516825130&text=Hola%20Montironi!%20"
            target="_blank"
            rel="noreferrer"
          >
            <img src={WhatsappFlotante} alt="Whatsapp" />
          </a>
        ) : null}
        {marcas === "jeep" ? (
          <a
            href="https://api.whatsapp.com/send?phone=543516825130&text=Hola%20Montironi!%20"
            target="_blank"
            rel="noreferrer"
          >
            <img src={WhatsappFlotante} alt="Whatsapp" />
          </a>
        ) : null}
      </div>
    </footer>
  );
};
